import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { payoutsEndpoints } from '../data/apiData';

export const Payouts: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Payouts</h1>
        <p className="text-lg text-gray-500 mb-6">
          Send money to any Nigerian bank account instantly. The payout system supports extensive connectivity with Nigerian banks and financial providers
          and includes features like name verification and real-time status tracking.
        </p>
        
        <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-6 mb-6">
          <h3 className="text-lg font-semibold text-amber-500 mb-3">Payout Process</h3>
          <ol className="list-decimal list-inside text-sm text-amber-500/90 space-y-2">
            <li><strong>Get Banks:</strong> Retrieve the list of supported banks with their codes and names</li>
            <li><strong>Name Enquiry:</strong> Verify the recipient's account name before initiating transfer</li>
            <li><strong>Initiate Transfer:</strong> Send money to the verified account with a unique reference</li>
            <li><strong>Track Status:</strong> Monitor the transfer progress using the reference ID</li>
          </ol>
        </div>

        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 text-center">
            <div className="text-2xl font-bold text-green-500 mb-2">570+</div>
            <div className="text-sm text-green-500/80">Supported Banks</div>
          </div>
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 text-center">
            <div className="text-2xl font-bold text-blue-500 mb-2">Real-time</div>
            <div className="text-sm text-blue-500/80">Status Tracking</div>
          </div>
          <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4 text-center">
            <div className="text-2xl font-bold text-purple-500 mb-2">Instant</div>
            <div className="text-sm text-purple-500/80">Name Verification</div>
          </div>
        </div> */}

        <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 mb-8">
          <h3 className="text-sm font-semibold text-red-500 mb-2">Important Security Notes</h3>
          <ul className="list-disc list-inside text-sm text-red-500/90 space-y-1">
            <li>Always perform name enquiry before initiating transfers to prevent errors</li>
            <li>Double-check account numbers - incorrect details may result in failed transfers</li>
            <li>Keep transfer references safe for tracking and reconciliation</li>
            <li>Monitor your account balance before making large transfers</li>
          </ul>
        </div>
      </div>

      <div className="space-y-8">
        {payoutsEndpoints.map((endpoint) => (
          <ApiEndpoint key={endpoint.id} endpoint={endpoint} />
        ))}
      </div>
    </div>
  );
};